import { createContext, ReactNode } from 'react';

export const defaultPanelNavigatorContext: {
  getCurrentPanel?: () => string;
  renderNavigation?: ReactNode;
} = {};
export const PanelNavigatorContext = createContext(
  defaultPanelNavigatorContext
);
export const { Consumer, Provider } = PanelNavigatorContext;
